<agpr-dialog-container
    id="monitoringSearch.backfillDialog"
    heading="Monitoring.search.backfillDialog.heading"
    (close)="cancel()"
>

    <agpr-scroll-panel>
        <div class='agpr-topicBackfillDialog-content'>
            <p class='agpr-topicBackfillDialog-content-message' [innerHTML]="'Monitoring.search.backfillDialog.messageHtml' | localize:{name: topic.name}"></p>
            <div class="agpr-topicBackfillDialog-form">
                <agpr-date-range-selector
                    header="Monitoring.search.backfillDialog.dateRange"
                    [options]="dateFilterOptions"
                    [(ngModel)]="selectedOption"
                    [dateRange]="allowedRange"
                    [useToDate]="true"
                    (ngModelChange)="updateDatequery($event.value.query)"
                >
                </agpr-date-range-selector>
            </div>
            <div class="agpr-topicBackfillDialog-destinationFolder">
                <agpr-bulk-action-form-folder
                    [parameters] = "folderBulkActionParameters"
                    [(ngModel)]="selectedFolder"
                    (ngModelChange)="folderSelected($event)"
                    [heading]="'Monitoring.search.backfillDialog.destinationFolder' | localize"
                    [tooltip]="'Monitoring.search.backfillDialog.tooltip'">
                </agpr-bulk-action-form-folder>
                <agpr-form-message *ngIf="noFolderSelected">
                    {{'Monitoring.search.backfillDialog.noFolderSelected' | localize }}
                </agpr-form-message>
            </div>
            <agpr-message [severity] = "messageSeverityEnum.info">
                <p [innerHtml] ="'Monitoring.search.backfillDialog.infoMessage' | localize"></p>
            </agpr-message>
        </div>
    </agpr-scroll-panel>

    <ng-template #footerLeft>
        <agpr-button
            id="monitoringSearch.backfillDialog.cancel"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="monitoringSearch.backfillDialog.ok"
            [style]="buttonTypes.primary"
            label="Monitoring.search.backfillDialog.ok"
            (click)="ok()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>